<template>
  <div class="sidebar-container">
    <div class="sidebar" :style="`width: ${width}px`">
      <div class="sidebar-header">Articles</div>

      <div v-if="loading" class="spinner-container">
        <div class="spinner-border spinner-light"></div>
      </div>
      <ul v-else-if="articles.length" class="sidebar-items">
        <li
          :title="(2147483647 - article.stimestamp)|formatDate"
          :class="{ selected: (selectedArticle != null && selectedArticle.id_link === article.id_link) }"
          v-for="(article, i) in articles" :key="'article-' + i">
          <router-link event="" @click.native.prevent="selectArticle(article)"
                       :to="{ name: 'home', query: { id_link: article.id_link }}">

            <ImpactBar v-if="articleImpactLoading || article.id_link in articleImpact"
                       :real="(article.id_link in articleImpact) ? articleImpact[article.id_link].real_impact : 0"
                       :potential="(article.id_link in articleImpact) ? articleImpact[article.id_link].potential_impact : 0"
                       :positive="(article.id_link in articleImpact) ? articleImpact[article.id_link].positive : true"
                       :loading="articleImpactLoading"/>

            {{ (2147483647 - article.stimestamp)|formatRelative }}:
            {{ article.header }}
          </router-link>
        </li>
      </ul>
      <div v-else>
        <span class="no-results">No articles found, try reloading.</span>
      </div>
    </div>
    <div class="resize" @mousedown="dragStart"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ImpactBar from './ImpactBar'

export default {
  name: 'ArticleSidebar',
  components: { ImpactBar },
  data: () => ({
    width: 300,
  }),
  methods: {
    selectArticle(article) {
      this.$store.commit('article/setSelected', article)
    },
    dragStart(event) {
      if (event.button !== 0) {
        return
      }

      document.getElementById('drag-protect').style.display = 'block'
      document.addEventListener('mousemove', this.drag)
      document.addEventListener('mouseup', this.dragStop)
    },
    dragStop() {
      document.getElementById('drag-protect').style.display = 'none'
      document.removeEventListener('mouseup', this.dragStop)
      document.removeEventListener('mousemove', this.drag)
      this.draggingCallback = null
    },
    drag(e) {
      this.width = e.pageX
    }
  },
  props: ['loading'],
  computed: {
    ...mapState('article', {
      articles: state => state.latestArticles,
      selectedArticle: state => state.selected,
    }),
    ...mapState('hint', {
      impactLoading: state => state.impactLoading,
      articleImpact: state => state.articleImpact,
      articleImpactLoading: state => state.articleImpactLoading,
    }),
    ...mapState('site', {
      site: state => state.data,
    })
  }
}
</script>

<style scoped lang="sass">
@use '../styles/variables' as v

.sidebar-container
  grid-area: sidebar
  z-index: 1000
  overflow-y: auto
  overflow-x: hidden
  width: 100%
  display: flex

  .resize
    cursor: ew-resize
    height: 100%
    position: relative
    width: 1px
    border-left: v.$ui-border

    &:after
      content: ""
      width: 8px
      height: 100%
      left: -3px
      position: absolute


  .sidebar
    min-height: 100%
    background: v.$ui-background
    border-right: v.$ui-border
    color: v.$white
    display: grid
    grid-template-rows: auto 1fr

    .sidebar-header
      font-weight: bold
      font-size: v.$font-size
      text-align: center
      margin: 5px 0 10px

    .sidebar-items
      font-size: v.$font-size-small
      overflow-x: hidden

      li
        white-space: nowrap
        overflow: hidden

        .impact-bar
          width: 50px
          display: inline-block

        a
          color: v.$light-gray
          padding: 2px 15px 0 5px
          display: block
          overflow: hidden
          text-overflow: ellipsis

          &:hover
            text-decoration: none

        a:hover,
        &.selected
          background: v.$light-black2
</style>
